import { render, staticRenderFns } from "./GoodsZdbook.vue?vue&type=template&id=3fcd3e97&"
import script from "./GoodsZdbook.vue?vue&type=script&lang=js&"
export * from "./GoodsZdbook.vue?vue&type=script&lang=js&"
import style0 from "./GoodsZdbook.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports